import React from "react";
import { FormattedMessage } from "react-intl";
import { ConfirmDialog } from "../ConfirmDialog";
import { BulletList } from "../ConfirmDialog/BulletList.styles";
import { saveWarningsMessages } from "./SaveWarningsDialog.messages";
import { SaveWarningsDialogProps } from "./useSaveWarningsDialog";

/** Rendered as React text: the warnings name extras and properties that come from the backend. */
export function SaveWarningsDialog({
  show,
  title,
  summary,
  messages,
  onAccept,
}: SaveWarningsDialogProps) {
  return (
    <ConfirmDialog
      show={show}
      title={title ?? <FormattedMessage {...saveWarningsMessages.title} />}
      confirmLabel={<FormattedMessage {...saveWarningsMessages.accept} />}
      onConfirm={onAccept}
      onCancel={onAccept}>
      <p>{summary ?? <FormattedMessage {...saveWarningsMessages.intro} />}</p>
      {messages.length > 0 && (
        <BulletList>
          {messages.map((message, index) => (
            <li key={index}>{message}</li>
          ))}
        </BulletList>
      )}
    </ConfirmDialog>
  );
}
